/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Cut_LabelInputs */



/**
* | output |
* | --- |
* | "Cut selected events" |
*
* @param {Context_Menu_Cut_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_cut_label = /** @type {((inputs?: Context_Menu_Cut_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Cut_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse kürzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglia gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вырезать выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪辑选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを切り取る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं को काटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recortar eventos selecionados")
	return /** @type {LocalizedString} */ ("Cut selected events")
});